var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import * as PropTypes from 'prop-types';
import { UIComponent, childrenExist, commonPropTypes, } from '../../lib';
import Slot from '../Slot/Slot';
/**
 * A segment is used to create a grouping of related content.
 */
var Segment = /** @class */ (function (_super) {
    __extends(Segment, _super);
    function Segment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Segment.prototype.renderComponent = function (_a) {
        var ElementType = _a.ElementType, classes = _a.classes, rest = _a.rest;
        var _b = this.props, children = _b.children, content = _b.content;
        return (React.createElement(ElementType, __assign({}, rest, { className: classes.root }), childrenExist(children) ? children : Slot.create(content)));
    };
    Segment.className = 'ui-segment';
    Segment.displayName = 'Segment';
    Segment.propTypes = __assign({}, commonPropTypes.createCommon({
        content: 'shorthand',
    }), { inverted: PropTypes.bool });
    Segment.defaultProps = {
        as: 'div',
    };
    return Segment;
}(UIComponent));
export default Segment;
